import React from "react";
import { useRole } from "../context/RoleContext";
import { supabase } from "../services/supabase";

const TopBar = () => {
  const { currentMode, canSwitchMode, switchMode } = useRole();

  const handleLogout = async () => {
    await supabase.auth.signOut();
    window.location.reload();
  };

  return (
    <header className="topbar">
      <div className="topbar-left">
        <span className="topbar-title">
          {currentMode === "admin" ? "Mode Admin" : "Mode Répartiteur"}
        </span>
      </div>

      <div className="topbar-right">
        {canSwitchMode && (
          <button className="btn-secondary" onClick={switchMode}>
            Passer en {currentMode === "admin" ? "Répartiteur" : "Admin"}
          </button>
        )}

        <button className="btn-danger" onClick={handleLogout}>
          Déconnexion
        </button>
      </div>
    </header>
  );
};

export default TopBar;

